
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/urunler/[slug]/[id]",
      function () {
        return require("private-next-pages/urunler/[slug]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/urunler/[slug]/[id]"])
      });
    }
  